module.exports = __webpack_public_path__ + "static/img/Jackie_Cheung.a2e295f8.jpg";